import * as Yup from "yup";
import React from "react";

import { TranslatedText, getComuniServiti } from "../../../helpers/helpers";
import { SimpleCaseType } from "../../../helpers/enums";
import { validEmail, validPhone } from "../../forms/CustomSignUp/validations";
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,
} from "../../../helpers/enums";
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";
// Il model definisce la struttura dei dati
// formId è un identificatore del form
// formField contiene la definizione dei singoli campi
const model = {
  formId: CaseForms.SegnalaUnGuasto,
  formField: {
    comunePuf: {
      name: "comunePuf",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "suggestions",
      message: true,

      getItems: (setData) => {
        return getComuniServiti()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter((item) => {
          return (
            String(item.comune)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        indirizzoPuf.city = value;
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        if (selected) {
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.comune) : setValue("");
      },
    },
    indirizzoPuf: {
      name: "indirizzoPuf",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.indirizzo.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "egon-address",
      suggestionType: "address",
      city: "",
      onChange: (setFieldValue, value) => {
        setFieldValue(indirizzoPuf.name, value);
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(indirizzoPuf.name, isStreetValid ? `${components.via} ${components.civico}` : '');
        egonCodeResponse.tipo_Indirizzo="puf";
        setFieldValue(addressList.name, [egonCodeResponse]);
      },
    },
    integraClientCode: {
      name: "integraClientCode",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codice_cliente.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      type: "input",
    },
    type: {
      name: "type",
      label: <TranslatedText i18nKey="cases.request_info.fields.tipo.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      type: "radio",
      options: [
        { label: <TranslatedText i18nKey="opere.acquedotto"/>, value: SimpleCaseType.SERVICE_AQUEDUCT },
        { label: <TranslatedText i18nKey="opere.fognatura"/>, value: SimpleCaseType.SERVICE_SEWER },
      ],
    },
    businessName: {
      name: "businessName",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.ragione_sociale.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    landlinePhoneNumber: {
      name: "landlinePhoneNumber",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.telefono.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
      ),
      type: "input",
    },
    mobilePhoneNumber: {
      name: "mobilePhoneNumber",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      invalidNumberErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.cellphone.match" />
      ),
      type: "input",
    },
    email: {
      name: "email",
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    pec: {
      name: "pec",
      label: <TranslatedText i18nKey="cases.request_info.fields.pec.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />
      ),
      type: "input",
    },
    note: {
      name: "note",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.nome_utente.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "text",
    },
    captcha: {
      name: "captcha",
      label: <TranslatedText i18nKey="cases.richiedi_omaggio.captcha.label" />,
      type: "captcha",
    },
    addressList : {
      name : "addressList",
    },
  },
};

const {
  formField: {
    comunePuf,
    indirizzoPuf,
    integraClientCode,
    type,
    businessName,
    landlinePhoneNumber,
    mobilePhoneNumber,
    email,
    pec,
    note,
    captcha,
    addressList,
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [comunePuf.name]: "",
  [indirizzoPuf.name]: "",
  [integraClientCode.name]: "",
  [type.name]: SimpleCaseType.SERVICE_AQUEDUCT,
  [businessName.name]: "",
  [landlinePhoneNumber.name]: "",
  [mobilePhoneNumber.name]: "",
  [email.name]: "",
  [pec.name]: "",
  [note.name]: "",
  [captcha.name]: "",
  [addressList]: "",
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = () => {
  return [
    Yup.object().shape({
      [comunePuf.name]: Yup.string().required(comunePuf.requiredErrorMsg),
      [indirizzoPuf.name]: Yup.string().required(indirizzoPuf.requiredErrorMsg),
      [landlinePhoneNumber.name]: Yup.string().matches(validPhone, {
        message: landlinePhoneNumber.invalidErrorMsg,
      }),
      [mobilePhoneNumber.name]: Yup.string().matches(validPhone, {
        message: mobilePhoneNumber.invalidErrorMsg,
      }).required(mobilePhoneNumber.requiredErrorMsg).max(15, mobilePhoneNumber.invalidNumberErrorMsg),
      [email.name]: Yup.string().matches(validEmail, {
        message: email.invalidErrorMsg,
      }).required(email.requiredErrorMsg),
      [pec.name]: Yup.string().matches(validEmail, {
        message: pec.invalidErrorMsg,
      }),
      [businessName.name]: Yup.string().required(businessName.requiredErrorMsg),
      [note.name]: Yup.string().required(note.requiredErrorMsg),
      [captcha.name]: Yup.string().required(note.requiredErrorMsg),
    }),
  ];
};
// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (privacyLink, privacyCtaLabel) => {
  return ([
    {
      chapter: true,
      chapterName: "Form semplice 1",
      title: "",
      fields: [
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.request_info.titles.title1" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: comunePuf.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: indirizzoPuf.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: integraClientCode.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "type",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.request_info.titles.title2" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: businessName.name,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: landlinePhoneNumber.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: mobilePhoneNumber.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "email",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "pec",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.request_info.titles.title3" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },

        {
          fieldName: note.name,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: captcha.name,
          grid: {
            xs: 12,
          },
        },
      ],
      content: (
        <div>
          <p>
            <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
          </p>
          <p>
            <TranslatedText i18nKey="cases.info.legal2" />
          </p>
        </div>
      ),
    },
  ])
}

// Contiene dettagli sul case form
const formDetails = {
  title: <TranslatedText i18nKey="cases.segnala_un_guasto.title" />,
  description: null,
  summary: false,
  stepper: CaseStepperType.None,
  // belowText: (
  //   <div className="content">
  //     <Trans
  //       i18nKey="cases.segnala_un_guasto_footer_text"
  //       components={{ul: <ul/>, li: <li/>,a: <a href={"mailto:prontointervento@gruppocap.it"} rel="noopener noreferrer" target="_blank">{''}</a>}}
  //     />
  //   </div>
  // ),
  helpText: null,
  successText: (
    <div>
      <p>
        <TranslatedText i18nKey="cases.request_info.success_text" />
      </p>
    </div>
  ),
};
const mutation = {
  type: CaseMutationType.Simple,
};

const main = (excludeSteps, counter, signDigital, webviewPopup, webviewRedirectPopup, buttonMatricolaContatoreCase, privacyLink, privacyCtaLabel) => {
  const layout = getLayout(privacyLink, privacyCtaLabel);
  return {
    model,
    validationSchema: getValidationSchema(),
    initialValues,
    layout,
    formDetails,
    mutation,
  };
};

export default main;
